import React from 'react';

function Training() {
  return (
    <>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: "900px" }}>
          <h3 className="text-white display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">Our Training</h3>
          <ol className="breadcrumb justify-content-center text-white mb-0 wow fadeInDown" data-wow-delay="0.3s">
            <li className="breadcrumb-item"><a href="index.html" className="text-white">Home</a></li>
            <li className="breadcrumb-item"><a href="#!" className="text-white">Pages</a></li>
            <li className="breadcrumb-item active text-secondary">Training</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* Training Start */}
      <div className="container-fluid training overflow-hidden bg-light py-5">
        <div className="container py-5">
          <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            <div className="sub-style">
              <h5 className="sub-title text-primary px-3">CHECK OUR TRAINING</h5>
            </div>
            <h1 className="display-5 mb-4">Get the Best Coacing Service Training with Our Travisa</h1>
            <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat deleniti amet at atque sequi quibusdam cumque itaque repudiandae temporibus, eius nam mollitia voluptas maxime veniam necessitatibus saepe in ab? Repellat!</p>
          </div>
          <div className="row g-4">
            <div className="col-lg-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.1s">
              <div className="training-item">
                <div className="training-inner">
                  <img src="img/training-1.jpg" className="img-fluid w-100 rounded" alt="Image" />
                  <div className="training-title-name">
                    <a href="#!" className="h4 text-white mb-0">IELTS</a>
                    <a href="#!" className="h4 text-white mb-0">Coaching</a>
                  </div>
                </div>
                <div className="training-content bg-secondary rounded-bottom p-4">
                  <a href="#!"><h4 className="text-white">IELTS Coaching</h4></a>
                  <p className="text-white-50">Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem, veritatis.</p>
                  <a className="btn btn-secondary rounded-pill text-white p-0" href="#!">Read More <i className="fa fa-arrow-right"></i></a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.3s">
              <div className="training-item">
                <div className="training-inner">
                  <img src="img/training-2.jpg" className="img-fluid w-100 rounded" alt="Image" />
                  <div className="training-title-name">
                    <a href="#!" className="h4 text-white mb-0">TOEFL</a>
                    <a href="#!" className="h4 text-white mb-0">Coaching</a>
                  </div>
                </div>
                <div className="training-content bg-secondary rounded-bottom p-4">
                  <a href="#!"><h4 className="text-white">TOEFL Coaching</h4></a>
                  <p className="text-white-50">Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem, veritatis.</p>
                  <a className="btn btn-secondary rounded-pill text-white p-0" href="#!">Read More <i className="fa fa-arrow-right"></i></a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.5s">
              <div className="training-item">
                <div className="training-inner">
                  <img src="img/training-3.jpg" className="img-fluid w-100 rounded" alt="Image" />
                  <div className="training-title-name">
                    <a href="#!" className="h4 text-white mb-0">PTE</a>
                    <a href="#!" className="h4 text-white mb-0">Coaching</a>
                  </div>
                </div>
                <div className="training-content bg-secondary rounded-bottom p-4">
                  <a href="#!"><h4 className="text-white">PTE Coaching</h4></a>
                  <p className="text-white-50">Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem, veritatis.</p>
                  <a className="btn btn-secondary rounded-pill text-white p-0" href="#!">Read More <i className="fa fa-arrow-right"></i></a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
              <div className="training-item">
                <div className="training-inner">
                  <img src="img/training-4.jpg" className="img-fluid w-100 rounded" alt="Image" />
                  <div className="training-title-name">
                    <a href="#!" className="h4 text-white mb-0">OET</a>
                    <a href="#!" className="h4 text-white mb-0">Coaching</a>
                  </div>
                </div>
                <div className="training-content bg-secondary rounded-bottom p-4">
                  <a href="#!"><h4 className="text-white">OET Coaching</h4></a>
                  <p className="text-white-50">Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem, veritatis.</p>
                  <a className="btn btn-secondary rounded-pill text-white p-0" href="#!">Read More <i className="fa fa-arrow-right"></i></a>
                </div>
              </div>
            </div>
            <div className="col-12 text-center">
              <a className="btn btn-primary border-secondary rounded-pill py-3 px-5 wow fadeInUp" data-wow-delay="0.1s" href="#!">View More</a>
            </div>
          </div>
        </div>
      </div>
      {/* Training End */}
    </>
  );
}

export default Training;
